import Stomp from "webstomp-client";

const FirstAlertSocket = {
    subscriptionId: 1,
    stompClient: null,
    websocket : null,
    subscriptions : [],
    getId() {
        const id = this.subscriptionId;
        this.subscriptionId++;
        return id;
    },
    connect(cb) {
        const authToken = sessionStorage.getItem("_ct_");
        let url = process.env.VUE_APP_SERVER_URL + "streams";
        if (url.startsWith("https:")) {
            url = "wss:" + url.substring(6);
        } else {
            url = "ws:" + url.substring(6);
        }

        this.websocket = new WebSocket(url);

        this.websocket.onerror = function() {

        }
        this.stompClient = Stomp.over(this.websocket);
        this.stompClient.connect({
            'Authorization': authToken
        }, () => {
            for (let id in this.subscriptions) {
                this.resubscribe(id);
            }
            cb();
        }, () => {
            setTimeout(() => {
                this.connect(cb);
            },5000);
        });
    },
    resubscribe(subscriptionId) {
        const subscriptionObj = this.subscriptions[subscriptionId];
        if (subscriptionObj) {
            let newObj = {
                callback: subscriptionObj.callback,
                streamUri: subscriptionObj.streamUri
            }
            let subscription = this.stompClient.subscribe(newObj.streamUri,(message) => {
                newObj.callback(message);
            });
            newObj.subscription = subscription;
            this.unsubscribe(subscriptionId);
            this.subscriptions[subscriptionId] = newObj;
        }
    },
    subscribe(streamUri,callback) {
        const id = this.getId();
        let subscription = this.stompClient.subscribe(streamUri,(message) => {
            callback(message);
        });
        this.subscriptions[id] = { streamUri,callback,subscription};
        return id;
    },
    unsubscribe(subscriptionId) {
        const subscriptionObj = this.subscriptions[subscriptionId];
        if (subscriptionObj) {
            subscriptionObj.subscription.unsubscribe();
            delete this.subscriptions[subscriptionId];
        }
    },
    disconnect() {
        this.stompClient.disconnect();
    }

}

export default FirstAlertSocket